module.exports = __webpack_public_path__ + "static/img/ml-huillier-icon.a0f4a82b.png";